// src/redux/cardsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_URL, getTravellInfoApi } from "../../utils/Constants";

// Async thunk for fetching data
export const getTravellInfo = createAsyncThunk(
    "getTravellInfo",
    async (payload) => {
        const token = localStorage.getItem("Token");
        const headers = {
            Authorization: token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
        };
        try {
            const response = await axios.post(
                `${BASE_URL}${getTravellInfoApi}`,
                payload,
                { headers }
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);

const getTravellInfoSlice = createSlice({
    name: "getTravellInfo",
    initialState: {
        data: null,
        loading: "idle",
        error: null,
    },
    reducers: {
        clearBookingData: (state) => {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTravellInfo.pending, (state) => {
                state.loading = "pending";
            })
            .addCase(getTravellInfo.fulfilled, (state, action) => {
                state.loading = "idle";
                state.data = action.payload;
                state.error = null;
            })
            .addCase(getTravellInfo.rejected, (state, action) => {
                state.loading = "idle";
                state.error = action.error.message;
            });
    },
});
export const { clearTravellInfoData } = getTravellInfoSlice.actions;
export default getTravellInfoSlice.reducer;
